import { render } from "./RestaurantCategoriesView.vue?vue&type=template&id=0b3cf96c&scoped=true"
import script from "./RestaurantCategoriesView.vue?vue&type=script&lang=js"
export * from "./RestaurantCategoriesView.vue?vue&type=script&lang=js"

import "./RestaurantCategoriesView.vue?vue&type=style&index=0&id=0b3cf96c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3cf96c"]])

export default __exports__